import { loadStripe, Stripe } from "@stripe/stripe-js";
import { TokenPackage } from "../types";

// Stripe Public Keys
const STRIPE_TEST_PUBLIC_KEY =
  "pk_test_51SYBbVPSvXMkLExxzIWPHoj7vOe1cWUIaJG916NvzdZCuex41WWuydRWI3oeieCPcLrfArI8lvyhtSBqSFrm4CzT007DfpLEFR";
const STRIPE_LIVE_PUBLIC_KEY =
  "pk_live_51SYBbLAqc5GkvyspnraDveZetxRqZv8U2qBVgtchSYPId78Yiioa3UUmvDyWhnXOSSYDDY86zgJ7EphH9qe2Ooqy00wUSAmJKx"; // TODO: Replace with actual live key when available

// Initialize Stripe - cached per mode
let stripeTestPromise: Promise<Stripe | null> | null = null;
let stripeLivePromise: Promise<Stripe | null> | null = null;

export const getStripe = (isTestMode: boolean = true) => {
  if (isTestMode) {
    if (!stripeTestPromise) {
      stripeTestPromise = loadStripe(STRIPE_TEST_PUBLIC_KEY);
    }
    return stripeTestPromise;
  } else {
    if (!stripeLivePromise) {
      stripeLivePromise = loadStripe(STRIPE_LIVE_PUBLIC_KEY);
    }
    return stripeLivePromise;
  }
};

// Default Token Packages (fallback if Firebase not available)
export const DEFAULT_TOKEN_PACKAGES: TokenPackage[] = [
  {
    packageId: "starter",
    name: "Starter Pack",
    tokens: 500,
    bonusTokens: 0,
    priceUsdCents: 499,
    stripePriceId: "prod_TVDGhG0DvWmDIL",
    isActive: true,
    sortOrder: 1,
    description: "Perfect for getting started",
  },
  {
    packageId: "popular",
    name: "Popular Pack",
    tokens: 1200,
    bonusTokens: 100,
    priceUsdCents: 999,
    stripePriceId: "prod_TVExzZiB4eieID",
    isActive: true,
    sortOrder: 2,
    description: "Most popular choice",
    badge: "Popular",
  },
  {
    packageId: "value",
    name: "Best Value",
    tokens: 3000,
    bonusTokens: 500,
    priceUsdCents: 1999,
    stripePriceId: "prod_TVEyGCyL3C5lLF",
    isActive: true,
    sortOrder: 3,
    description: "Best bang for your buck",
    badge: "Best Value",
  },
  {
    packageId: "whale",
    name: "Whale Pack",
    tokens: 10000,
    bonusTokens: 2500,
    priceUsdCents: 4999,
    stripePriceId: "prod_TVEzC3kOtSSPV1",
    isActive: true,
    sortOrder: 4,
    description: "For serious players",
  },
];

// Re-export for backwards compatibility - consumers should migrate to useTokenPackages hook
export const TOKEN_PACKAGES = DEFAULT_TOKEN_PACKAGES;

// Format price for display
export const formatPrice = (cents: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
};

// Calculate price per token
export const pricePerToken = (cents: number, tokens: number): string => {
  const pricePerToken = cents / tokens;
  return `$${(pricePerToken / 100).toFixed(3)}/GT`;
};
